'use strict';

import authModalLoader from 'dibs-buyer-layout/src/utils/AuthModalLoader';

// pass off authentication process to the Auth modal
module.exports = authProps => {
    const { action, email, linkLocation, flow } = authProps;
    return authModalLoader.show({
        action,
        email,
        flow: flow || authModalLoader.constants.CONTACT_DEALER_FLOW,
        step: 1,
        ga: {
            label: linkLocation,
        },
    });
};



// WEBPACK FOOTER //
// ./assets/js/contact/shared/helpers/relayAuthHelper.es.js